import { render, staticRenderFns } from "./MovesList.vue?vue&type=template&id=3876698a&scoped=true&"
import script from "./MovesList.vue?vue&type=script&lang=js&"
export * from "./MovesList.vue?vue&type=script&lang=js&"
import style0 from "./MovesList.vue?vue&type=style&index=0&id=3876698a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876698a",
  null
  
)

export default component.exports